export default __webpack_public_path__ + "static/media/slack.dbf02e40.png";